<template>
  <div v-loading="loading" class="detail-main">
    <div class="el-row" v-if="formInfo.processName">
      <div class="el-col el-col-14 process-form-content">
        <div class="process-title">审批详情</div>
        <div v-if="formInfo.remark" class="process-remark">
          <el-icon class="el-icon-warning-outline"></el-icon>{{formInfo.remark}}
        </div>
        <user-info :user="userInfo" />
        <div class="form-info">
          <div class="row">
            <div class="label">审批单名称：</div>
            <div class="name">{{formInfo.processName}}</div>
          </div>
          <div class="row">
            <div class="label">审批编号：</div>
            <div class="name">{{formInfo.serialNumber}}</div>
          </div>
          <div class="row">
            <div class="label">所在部门：</div>
            <div class="name">{{formInfo.initiatorDepartmentHierarchy}}</div>
          </div>
        </div>
        <!-- {{ formData }}  -->
                 <!-- {{forms}} -->
        <form-render class="process-form" ref="form" :forms="displayForms" v-model="formData" :userInfo="userInfo"  :readerMode="true"/>
        <notice-approval-preview v-if="noticePreview" :preview="noticePreview" />
      </div>
      <div class="el-col el-col-10 process-timeline">
          <div class="title-timeline">审批流程</div>
          <process-timeline :timeline="timeline"/>
      </div>
    </div>
  </div>
</template>

<script>
import NoticeApprovalPreview from './NoticeApprovalPreview.vue'
import FormRender from '@/pages/officeApproval/common/form/FormRender'
import UserInfo from '@/pages/officeApproval/approvalList/components/userInfo'
// import { getFormDetailV2 } from "@/api/design";
import OrgPicker from "@/components/OrgPicker";
import ProcessTimeline from '@/pages/officeApproval/approvalList/components/processTimeline.vue'
import ProcessTimelineMixins from '@/pages/officeApproval/approvalList/components/processTimeline.js'

// import { formatIOSTime } from '@/utils/index.js' 
import formItemPermission from '@/pages/officeApproval/approvalList/mixins/formItemPermission.js'
import templateRemark from '@/pages/officeApproval/common/form/templateRemark'

const { filterDuplicateTemplateRemark } = templateRemark
export default {
  name: "Approvaldetail",
  mixins: [formItemPermission,ProcessTimelineMixins],
  components: { FormRender,UserInfo, OrgPicker,ProcessTimeline,NoticeApprovalPreview },
  props: {
    loadTimeline: {
      type: Boolean,
      default: true,
    },
  },
  // props: {
  //   code: {
  //     type: String,
  //     required: true,
  //   },
  // },
  data() {
    return {
      loading: false,
      noticePreview: null,
      formData: {},
      select: [],
      selectedNode: {},
      processUsers: {},
      form: {
        formId: "",
        formName: "",
        logo: {},
        formItems: [],
        process: {},
        remark: "",
        processTemplates:{}
      },
      conditionFormItem: new Set(),
      activities: [],
      userInfo:{},
      formInfo:{},
    };
  },
  created(){
  },
  activated() {
    // this.fetchData();
  },
  mounted() {
  },
  watch: {
    // 被侦听的变量count
    // formData: {
    //   // 对对象进行深度监听
    //   handler(nv) {
    //     this.startProcess(nv, (this.cc = []));
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    '$route.query.id': {
      handler: 'fetchData',
      immediate: true
    }
  },
  computed: {
   
    forms() {
      return this.$store.state.design.formItems;
    },
    displayForms() {
      return filterDuplicateTemplateRemark(this.forms, this.formInfo.remark)
    },
    _value: {
      get: function () {
        return this.value;
      },
      set: function (e) {
        this.$emit("input", e);
      },
    },
  },
  methods: {
    
    // iconStatus(text) {
    //   if(text==='已完成' || text==='通过'){
    //     return 'i-suc'
    //   }else if(text==='处理中'){
    //     return 'i-ing'
    //   }else if(text==='转交'){
    //     return 'i-zhuanjiao'
    //   }
    // },
    // ccStatus(text) {
    //   if(text==='全部已读'){
    //     return 'i-suc'
    //   }else{
    //     return 'i-ing'
    //   }
    // },
    getKeys(obj) {
      let keys = []
      for (let key in obj) {
        keys.push(key)
      }
      return keys
    },
    fetchData(){
      // console.log('>>',this.$route.name)
      let whiteName = ['approvalMyDetail','approvalManageDetail','approvalCCDetail','approvalAllDetail']
      if (whiteName.includes(this.$route.name)) {
          this.fetchDataTure()
      }
    },
    fetchDataTure() {
      let id = this.$route.query.id
      console.log('====>>test',)
      if(!id) return false
      let whiteName = ['addSatff','editSatff']
     
      const postData = {
        processInstanceId:id
      };
      this.loading = true;
      this.noticePreview = null
      this.formInfo = {}
      this.timeline = []
      this.formData = {}
      this.form = {
        processTemplates:''
      }
      console.log('workflowDetail:',postData)
      // 全部审批数据的详情和其他页面不一样
      const apiUrl = (this.$route.name === 'approvalAllDetail') ? 'workflowAdminDetail' : 'workflowDetail';
      this.$api[apiUrl](postData).then((res) => {
          console.log('>>',res ,this.$route.name)
          let data = Object.assign({}, res.data);
          let formItems = JSON.parse(data.processTemplates.formItems)
          
          // let process
          // let currentNodeId
          // let formItemsPerm
          // 只有我处理的页才获取权限
          // if(this.$route.name === 'approvalManageDetail'){
          //   // 获取当前节点的权限
          //   process =  JSON.parse(data.processTemplates.process)
          //   currentNodeId = data.runningList[data.runningList.length - 1]
          // }
          // if(currentNodeId){
          //    let permList = this.findNodePermission(process,currentNodeId)
          //    formItemsPerm = this.mergePermissions(formItems,permList)
          // }else{
          //   formItemsPerm = formItems
          // }
          this.noticePreview = data.noticePreview || null
          this.formData = res.data.formData;
          this.canReadFiled = this.getKeys(this.formData)
          this.canEditFiled = res.data.canEditFiled || '';
          // E 可编辑 R只读 H 隐藏
          formItems.forEach(e=>{
            if(this.canEditFiled.includes(e.id)){
              e.perm = 'E'
            }else  if(this.canReadFiled.includes(e.id)){
              e.perm = 'R'
            }else{
              e.perm = 'H'
            }
          })

          let commitData = {
           formItems:formItems
          }
          
          this.canEditFiled = res.data.canEditFiled;
          this.templateId = data.processTemplates.id;
          this.form = data;
          //表单内容存起来，方法修改
          this.$store.commit("setDesignForm", commitData);
          
          console.log('detail流程详情：',commitData)
          // 获取高级设置
          let settings = {}
          if (data.processTemplates.settings) {
            settings = JSON.parse(data.processTemplates.settings);
          }
          console.log('settings:',settings)
          // 
          // 用户信息
          this.userInfo = {
            name: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.initiator.name,
            id: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.initiator.id,
            statusText: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.processStatus,
            businessStatus: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.businessStatus
          }
          // 表头信息
          this.formInfo = {
            processName: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.processName,
            remark: data.processTemplates && data.processTemplates.remark,
            serialNumber: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.serialNumber,
            initiatorDepartmentHierarchy: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.initiatorDepartmentHierarchy,
          }
          // 获取时间轴
          // this.$nextTick(() => { 
          //   this.$refs.processTimeline.show(postData)
          // })
          
          // 审批流程
          // let timeline = data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.timeline || [];
          // timeline.forEach(e => {
          //     e.time = formatIOSTime(e.eventTime)
          //     // 审批和办理多人时
          //     if(e.itemType==='NODE' &&  e.approvers && e.approvers.length!==0){
          //       let personCount = e.approvers.length // 抄送人个数
          //       e.personCount = personCount
          //       e.personNames = e.approvers.map(item => ((item.departmentName?item.departmentName + ' ':'') + item.userName+(!item.isActive?'(已离职)':''))).join('、')
          //     }
          //     // 抄送处理
          //     if(e.itemType==='CC' &&  e.ccInfo && e.ccInfo.operatorList){
          //       let ccCount = e.ccInfo.operatorList.length // 抄送人个数
          //       let ccIsReadCount = e.ccInfo.operatorList.filter(item => item.isRead === 1).length // 已读个数
          //       if(ccIsReadCount===0){
          //         e.ccStatusText = '全部未读'
          //       }else if(ccIsReadCount===ccCount){
          //         e.ccStatusText = '全部已读'
          //       }else{
          //         e.ccStatusText = '部分已读'
          //       }
          //       e.ccCount = ccCount
          //       e.ccUserName = e.ccInfo.operatorList.map(item => (item.departmentName +' '+ item.operatorName+(!item.operatorActive?'(已离职)':'')+(item.isRead?'<span style="color:#00B498">(已读)</span>':'(未读)'))).join('、')
          //     }
          // })
          // this.timeline = timeline
          this.loading = false;
          // this.$emit("stauts", data.workflowHistoryResponseVO.businessStatus);
          this.$emit("detail", {
            status: data.workflowHistoryResponseVO && data.workflowHistoryResponseVO.businessStatus,
            currentTaskId: data.currentTaskId,
            processFinished: data.processFinished,
            canCancel:data.canCancel,
            canApprove:data.canApprove,
            canAddApprover:data.canAddApprover,
            canEdit:data.canEdit,
            canEditForm:data.canEditForm,
            mustApproveRemark:settings.mustApproveRemark,
            businessName: data.businessDetail && data.businessDetail.businessName, // 无形资产相关 
            businessId: data.businessDetail && data.businessDetail.detailId,  
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$emit("detail", {
            status: '',
            currentTaskId: '',
            processFinished:true
          });
          this.$message.error(err);
        });
      // 获取时间轴
      if (this.loadTimeline) {
        this.getTimeline(postData)
      }
    },
    // 保存历史审批数据，供正常发起页创建一份全新的审批
    prepareReapply() {
      const formData = JSON.parse(JSON.stringify(this.formData || {}))
      this.$store.commit("setEditForm", formData);
      return this.templateId
    },
    // 获取可编辑的formData
    getEditFormData(){
      // 返回forms中perm="E"的ID值，再把formData包括这些ID的对象返回
      return this.forms.filter(item => item.perm === 'E').map(item => item.id).reduce((pre, cur) => {
        pre[cur] = this.formData[cur]
        return pre
      }, {})
    },
    // 审批中 校验表单
    validate(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验成功，打开审批弹窗
          this.$emit("applay");
        } else {
          this.$message.warning("请完善表单");
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.detail-main{
  min-height: 50vh;
  
}
// .line{
//   &::before{
//     display: block;
//     content: '';
//     position: absolute;
//     background: #EDF2F2;
//     width: 1px;
//     position: absolute;
//     right: 41.66%;
//     top: 0;
//     bottom: 50px;
//   }
// }
// 左边表单内容
.process-form-content{
  // border-right: 1px solid #EDF2F2;
  // min-height: calc(100vh - 226px);
  /* background-color: red; */
  box-sizing: border-box;
  padding-right: 100px;
  .process-title{
    font-family: PingFang SC, PingFang SC;
    /* font-weight: bold; */
    font-size: 18px;
    color: #2F3030;
    padding: 6px;
    line-height: 1;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      width: 2px;
      height: 16px;
      background: #00B498;
    }
  }
  .process-remark{
    font-size: 14px;
    margin: 20px 0 -15px 0;
    line-height: 1.5;
    text-align: left;
    clear: both;
    color: #f00;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .form-info{
    padding-top: 19px;
  }
  .row{
    display: inline-flex;
    font-size: 14px;
    width: 100%;
    line-height: 44px;
    // margin: 0 0 14px 0;
    .label{
      color: #939696;
      padding-right: 8px;
    }
    .name{
      color: #2F3030;
    }
  }
}
/* 右边内容 */
.process-timeline{
  padding: 0 16px;
}
// 右边内容
.title-timeline{
  height: 112px;
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
  box-sizing: border-box;
  padding-top: 60px;
}


</style>
